module.exports = __webpack_public_path__ + "static/media/cb.814c44ea.png";